// extracted by mini-css-extract-plugin
module.exports = {"icon":"FacebookIcon_icon_2x_HF","facebook":"FacebookIcon_facebook_5XsXB"};